import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const CertificateConfigurationCreateForm = React.lazy(() => loadComponent('certification', 'CertificateConfigurationCreateForm'))

export function CertificateConfigurationCreateRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate('/certificate_configurations')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/certificate_configurations')
    }, [navigate])

    return (
        <RouteContainer>
            <CertificateConfigurationCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
